export default __webpack_public_path__ + "static/packing3-2cbe9c839a6a0699701dc168873f856b.jpg";